//
//
//
//
//
//
//
//
//
//
//

import CheckboxWrap from './checkbox_wrap'
export default {
    components: {
        CheckboxWrap
    },
    props: {
        options: {
            type: Array,
            default: () => ([])
        },
        selected: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            inner_selected: '',
            inner_text_selected: ''
        }
    },
    watch: {
        selected (selected) {
            this.inner_selected = selected
        }
    },
    destroyed () {
        this.reset()
    },
    methods: {
        change (selected, inner_text_selected) {
            this.inner_selected = selected.join(',')
            this.inner_text_selected = inner_text_selected
        },
        reset () {
            this.inner_selected = ''
            this.inner_text_selected = ''
        },
        confirm () {
            this.$emit('change', this.inner_selected, this.inner_text_selected)
        }
    }
}
